import { TimelineEngine } from '@xzdarcy/react-timeline-editor';

class VideoControl {
  listenerMap: Record<
    string,
    {
      time?: (data: { time: number }) => void;
    }
  > = {};

  #getElement(id: string) {
    return document.querySelector(`#videoLabel${id}`) as HTMLVideoElement;
  }

  start(data: {
    id: string;
    engine: TimelineEngine;
    startTime: number;
    time: number;
    from: number;
    hide: boolean;
  }) {
    const { id, startTime, time, from, engine, hide } = data;
    const item = this.#getElement(id);
    if (item) {
      item.currentTime = time - startTime + from;
      if (hide) {
        item.style.visibility = 'hidden';
      } else {
        item.style.visibility = 'visible';
        item.play();
      }

      const timeListener = (data: { time: number }) => {
        const { time } = data;
        item.currentTime = time - startTime + from;
      };
      if (!this.listenerMap[id]) this.listenerMap[id] = {};
      engine.on('afterSetTime', timeListener);
      this.listenerMap[id].time = timeListener;
    }
  }

  stop(data: { id: string; engine: TimelineEngine }) {
    const { id, engine } = data;
    const item = this.#getElement(id);
    if (item) {
      item.pause();
      if (this.listenerMap[id]) {
        this.listenerMap[id].time && engine.off('afterSetTime', this.listenerMap[id].time);
        delete this.listenerMap[id];
      }
    }
  }

  leave(data: { id: string; engine: TimelineEngine }) {
    this.stop(data);
    const item = this.#getElement(data.id);
    if (item) {
      item.style.visibility = 'hidden';
    }
  }

  update(data: {
    id: string;
    startTime: number;
    endTime: number;
    time: number;
    from: number;
    hide: boolean;
  }) {
    const { id, startTime, endTime, time, from, hide } = data;
    const item = this.#getElement(id);
    if (item) {
      item.currentTime = time - startTime + from;
      if (hide || time > endTime) {
        item.style.visibility = 'hidden';
      } else {
        item.style.visibility = 'visible';
      }
    }
  }
}

export default new VideoControl();
